export const environment = {
    production: false,
    prefixUrl: '',
    logoPath: "assets/img/seal.png",
    title: 'Lamp Pole Banner',
    subtitle: 'Management Site',
    mapSettings: {
        basemap: "dark-gray",
        center: "-81.6557,30.3212",
        zoom: "14",
    }
};
